import React, { memo, Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Thumbs, Pagination, EffectFade } from "swiper";
import 'swiper/css/effect-fade';
import { useSelector } from "react-redux";
import { imageUrlCheck } from "../../../utils/utils";
import { ReactComponent as PlayIcon } from "../assets/Icons/play2.svg";
import { ReactComponent as PauseIcon } from "../assets/Icons/pause2.svg";
import Translate from "../../../Components/MultiLanguage/Translate";
import imgLogo from "../../../assets/Images/imdb-logo.svg";

const PlutoFeatured = memo(({ data }) => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [animationKey, setAnimationKey] = useState(0);
  const [autoplayEnabled, setAutoplayEnabled] = useState(true);
  const [swiperInstance, setSwiperInstance] = useState(null);

  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.realIndex);
    setAnimationKey(prev => prev + 1);
  };

  const toggleAutoplay = () => {
    if (swiperInstance) {
      if (autoplayEnabled) {
        swiperInstance.autoplay.stop();
      } else {
        swiperInstance.autoplay.start();
      }
      setAutoplayEnabled(!autoplayEnabled);
    }
  };

  const replaceImage = (error) => {
    error.target.src = projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE;
  };

  return (
    <Fragment>
      <div className="pluto-featured-slider">
        <div className="pluto-slider">
          <div className="pluto-slider-container">
            <div className="pluto-slider-main">
              <Swiper
                thumbs={{
                  swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
                }}
                slidesPerView={1}
                spaceBetween={0}
                loop={true}
                autoplay={{
                  delay: 6000,
                  disableOnInteraction: false,
                }}
                speed={1500}
                effect="fade"
                fadeEffect={{
                  crossFade: true
                }}
                modules={[Navigation, Thumbs, Autoplay, Pagination, EffectFade]}
                pagination={{
                  el: '.pluto-navigation-dots',
                  clickable: true,
                  type: 'bullets',
                  bulletClass: 'pluto-bullet',
                  bulletActiveClass: 'active'
                }}
                onSwiper={setSwiperInstance}
                onSlideChange={handleSlideChange}
                className="pluto-swiper-container"
              >
                {data?.shows?.map((item, index, array) => {
                  const nextItem = array[(index + 1) % array.length];
                  
                  return (
                    <SwiperSlide key={index} className="pluto-slide">
                      <div className="pluto-content-area">
                        <div className="pluto-slide-details">
                          <div className="pluto-content-wrapper" key={`content-${index}-${animationKey}`}>
                            <h1 className="pluto-title">{item?.show_name}</h1>
                            <div className="pluto-meta">
                              <span className="pluto-categories">
                                {item?.rating && <span>{item?.rating}</span>}
                                {item?.categories && item?.categories.length > 0 && (
                                  <div className="pluto-genres">
                                      <Link
                                        to={item?.categories[0]?.key ? `/category/${item?.categories[0]?.key}?career=${item?.categories[0]?.key}` : '#'}
                                        className="pluto-genre-link"
                                      >
                                        {item?.categories[0]?.category_name}
                                      </Link>
                                  </div>
                                )}
                                <span>{item?.duration_text}</span>
                              </span>
                            </div>
                            
                            <p className="pluto-synopsis">{item?.synopsis}</p>
                            
                            <div className="pluto-actions">
                              <Link to={`/show-details/${item?.vanity_url}`} className="pluto-details-btn">
                                <Translate textKey={"details"} />
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="pluto-slide-backdrop">
                        {imageUrlCheck(item?.banner) === true ? (
                          <img 
                            loading="lazy" 
                            src={item?.banner} 
                            alt={item?.show_name} 
                            onError={(e) => replaceImage(e)}
                            className="main-slide-image"
                          />
                        ) : (
                          <img 
                            loading="lazy" 
                            src={`${process.env.REACT_APP_IMAGE_URL}${item?.banner}`} 
                            alt={item?.show_name}
                            onError={(e) => replaceImage(e)}
                            className="main-slide-image"
                          />
                        )}
                        <div className="pluto-gradient-overlay"></div>
                      </div>
                      
                      <div className="pluto-next-preview">
                        {imageUrlCheck(nextItem?.banner) === true ? (
                          <img 
                            loading="lazy" 
                            src={nextItem?.banner} 
                            alt={nextItem?.show_name} 
                            onError={(e) => replaceImage(e)}
                          />
                        ) : (
                          <img 
                            loading="lazy" 
                            src={`${process.env.REACT_APP_IMAGE_URL}${nextItem?.banner}`} 
                            alt={nextItem?.show_name}
                            onError={(e) => replaceImage(e)}
                          />
                        )}
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
              
              <div className="pluto-controls">
                <div className="pluto-playback-controls">
                  <div className="play" onClick={toggleAutoplay}>
                    {autoplayEnabled ? <PauseIcon /> : <PlayIcon />}
                  </div>
                  <div className="pluto-navigation-dots">
                    {data?.shows?.map((_, index) => (
                      <span 
                        key={index} 
                        className={index === activeIndex ? "active" : ""}
                        onClick={() => document.querySelector('.pluto-swiper-container').swiper.slideTo(index)}
                      ></span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
});

PlutoFeatured.displayName = "PlutoFeatured";
export default PlutoFeatured;
